module.exports = {"320903002":"张庄街道","320903003":"盐龙街道","320903004":"潘黄街道","320903012":"盐渎街道","320903050":"新都街道","320903051":"科城街道","320903100":"大纵湖镇","320903102":"楼王镇","320903103":"学富镇","320903105":"尚庄镇","320903108":"秦南镇","320903109":"龙冈镇","320903111":"郭猛镇","320903112":"大冈镇","320903403":"大纵湖旅游度假区","320903404":"台湾农民创业园"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320903.json
// module id = 1005
// module chunks = 0